import { render, staticRenderFns } from "./workbenchEnterpriseDetails.vue?vue&type=template&id=3375e414&scoped=true&"
import script from "./workbenchEnterpriseDetails.vue?vue&type=script&lang=js&"
export * from "./workbenchEnterpriseDetails.vue?vue&type=script&lang=js&"
import style0 from "./workbenchEnterpriseDetails.vue?vue&type=style&index=0&id=3375e414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3375e414",
  null
  
)

export default component.exports